import { useEffect } from "react";

type Props = {
    file: any;
};

export default function PDFViewer({ file }: Props) {

    useEffect(()=> {
    }, [file])

    // Değişiklikler:
    // 1. style={{ minHeight: "80vh" }} -> Ekran yüksekliğinin en az %80'ini kapla dedik.
    //    Bunu "100vh" yaparsanız tam ekran kaplar, "600px" yaparsanız sabit kalır.
    // 2. view=FitH -> PDF'i pencere genişliğine sığdır (Zoom level'ı ayarlar).
    
    return (
        <iframe 
            width="100%" 
            height="100%"
            style={{ minHeight: "75vh", border: "none" }} 
            src={`${file}#toolbar=1&navpanes=0&view=FitH`} 
        />
    );
}